import { PaymentSuccessScreenContainer } from "./PaymentSuccessScreen";

export default {
  PaymentSuccessScreenContainer,
};
